export const isTargetAreaGroup = (group, groupTypes) => {
  if (!group) {
    return false;
  }

  const groupType = groupTypes[group.type];

  return !!groupType && groupType.isDemand;
};
